import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UserDataService } from 'src/app/services/userData.service';
import { SignalRService } from '../../services/communications/signalr.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { UserRole } from '../../constants/constants';
import { AudioConnectorService } from '../../services/audioConnector.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../../services/communications/api.service';
import { PipesModule } from '../../pipes/pipes.module';
import { AssistanceModalComponent } from '../header/assistance-modal/assistance-modal.component';
import { Assistance } from '../../interfaces/assistance';
import { AssistanceCreateResponse } from '../../models/assistanceCreateResponse';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import {assistanceClose, assistanceReopen} from "../../constants/signalrMessages";


@Component({
  selector: 'directCall-assistances',
  imports: [MatSelectModule, MatFormFieldModule, TranslateModule, MatSlideToggleModule, PipesModule, MatButtonModule, MatTooltipModule],
  templateUrl: './assistances.component.html',
  styleUrls: ['./assistances.component.scss', '../../styles/components/panel.scss', '../../styles/components/select.scss']
})

export class AssistancesComponent {

  currentUserId;

  @Input() stickyMode: boolean = false;
  @Input() withMenu: boolean = false;
  @Output() close = new EventEmitter<string>();

  assisatancesStatesEnum: { [key: string]: number } = {};
  assisatancesStatesOptions: { key: string; value: number }[] = [];
  assistancePriorityEnum: { [key: string]: number } = {};

  addAssistance!: Subscription;
  messageReceived!: Subscription;
  UserRole = UserRole;

  isExpert: boolean;
  assistanceClosed: boolean = false;

  constructor(public userDataService: UserDataService, private signalRService: SignalRService, public audioConnectorService: AudioConnectorService, public dialog: MatDialog, private apiService: ApiService, private translate: TranslateService) {
    this.currentUserId = userDataService.Id!;
    this.isExpert = userDataService.isExpert();

    this.signalREventsHook();
  }

  ngOnInit(): void {
    this.apiService.getAssistancesStates().subscribe(result => {
      result.forEach(item => { this.assisatancesStatesEnum[item.name] = item.id; });
      this.assisatancesStatesOptions = result.map(item => ({ key: item.name, value: item.id })).sort((a, b) => a.value - b.value);
    });

    this.apiService.getAssistancesPriorities().subscribe(result => {
      this.assistancePriorityEnum = result;
      console.log(this.assistancePriorityEnum);
    });

  }

  ngOnDestroy() {
    this.addAssistance.unsubscribe();
  }


  closeChat() {
    this.close.emit();
  }

  signalREventsHook() {
    console.log("** signalREventsHook assistances");

    this.addAssistance = this.signalRService.onAddAssistance.subscribe(assetAssistance => {
      console.log("add new assistance", assetAssistance);
     if (this.userDataService.assetInfo.assistances.indexOf(assetAssistance) === -1) {
       this.userDataService.assetInfo.assistances.push(assetAssistance);
     }

    });

    this.messageReceived = this.signalRService.onChatMessageReceived.subscribe(data => {
      console.log("add new assistance", data);
      if (data.chatData.message == assistanceClose)
      {
        console.log("ClosedAssistance", data);
        this.userDataService.assetInfo.assistances=this.userDataService.assetInfo.assistances.filter(a=>a.id != data.chatData.assistanceId)
      }

    });

  }

  startAssistance(responsive: boolean) {
    var state = this.assisatancesStatesEnum['Open'];

    const closeAssistanceDialog = this.dialog.open(AssistanceModalComponent, {
      width: responsive ? '75%' : '50%',
      autoFocus: true,
      data: {
        assistancePriorityEnum: this.assistancePriorityEnum
      }
    });

    closeAssistanceDialog.afterClosed().subscribe((result) => {
      const { assistance, sendMail } = result;
      //if (assistance == undefined || assistance.name == '') this.assistanceState = this.userDataService.assetInfo.assistances[0].state;
      if (assistance != undefined && assistance.name != '') {
        assistance.state = state;
        this.createAssistance(assistance, sendMail);
      }
    });

  }

  createAssistance(assistance: Assistance, sendMail: boolean) {
    this.apiService.createAssitance(this.userDataService.assetInfo.id, this.userDataService.Id!, assistance).subscribe({
      next: (data: AssistanceCreateResponse) => {
        if (data == null) {
          console.log("No assistance data ", data);
          return;
        }
        console.log("Create assistance response:", data);

        if (sendMail) {
          this.sendEmail(assistance, data.openedDateStr);
        }

        window.open(data.link, '_blank');
      },
      error: (error) => { console.error(error); }
    });
  }

  reopenAssistance() {
    this.apiService.reopenAssitance(this.userDataService.assetInfo.id, this.userDataService.Id!).subscribe({
      next: (data: AssistanceCreateResponse) => {
        if (data == null) {
          console.log("No assistance data ", data);
          return;
        }
        console.log("Reopen assistance response:", data);
      },
      error: (error) => { console.error(error); }
    });
  }

  gotoAssistance(assistanceId: number) {
    this.apiService.getAssistanceLink(assistanceId, this.userDataService.Id!).subscribe({
      next: (data: any) => {
        if (data == null) {
          console.log("No assistance link ", data);
          return;
        }
        window.open(data.link, '_blank');
      },
      error: (error: any) => { console.error(error); }
    });
  }

  sendEmail(assistance: Assistance, openedDate: string) {
    let subject: string, startDate: string, name: string, comments: string;
    subject = startDate = name = comments = "";

    this.translate.get('EMAIL_NEW_ASSISTANCE.SUBJECT').subscribe((text: string) => { subject = text; });
    this.translate.get('EMAIL_NEW_ASSISTANCE.START_DATE').subscribe((text: string) => { startDate = text; });
    this.translate.get('EMAIL_NEW_ASSISTANCE.COMMENTS').subscribe((text: string) => { comments = text; });
    this.translate.get('EMAIL_NEW_ASSISTANCE.NAME').subscribe((text: string) => { name = text; });

    var body = `${name}: ${assistance.name} \n${startDate}: ${openedDate} \n${comments}: ${assistance.comments} \n`;
    console.log("body ", body);

    const mailtoLink = `mailto:?subject=${subject}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink);
  }

}
